import { ContainerUsage } from '@/class/model/booking/ContainerUsage'
import StrUtils from '@/utils/StrUtils'
import i18n from '@/lang'

export class ContainerManager {
  /**
   * @param {Object} data
   */
  constructor(data) {
    this._data = data || {}
    this.job = data
    this.removedContainerUsages = [] // 已经删除的
    this.removeSourceUsages = []//  原始装箱明细数据
  }
  /**
   * 已经删除的原始数据
   */
  clearRemoveSourceUsages() {
    this.removeSourceUsages = []
  }

  // /**
  //  * 获取可以分配的箱子，根据SeaEQ自动补全
  //  */
  // public function fillAllocableContainers():void
  // {
  //   var seaEQs:IList = job.seaEQ;
  //   var containers:IList = job.containers;
  //   for each (var seaEQ:SeaEQ in seaEQs)
  //   {
  //     var eqContainers:IList = getContainersBySeaEQ(seaEQ);
  //     var count:int = seaEQ.EQquantity - eqContainers.length;
  //     if (count > 0)
  //     {
  //       for (var i:int = 0; i < count; i++)
  //       {
  //         addContainer(seaEQ);
  //       }
  //     }
  //     else if (count < 0)
  //     {
  //       removeContainer(eqContainers, Math.abs(count));
  //     }
  //   }
  // }
  //
  // /**
  //  * 获取特定箱型的箱子
  //  */
  // public function getContainersBySeaEQ(seaEQ:SeaEQ):IList
  // {
  //   var containers:IList = new ArrayCollection();
  //   for each (var container:Container in job.containers)
  //   {
  //     if (container.EQsize == seaEQ.EQsize && container.EQtype == seaEQ.EQtype)
  //     {
  //       containers.addItem(container);
  //     }
  //   }
  //   return containers;
  // }
  //
  // /**
  //  * @private
  //  */
  // private function addContainer(seaEQ:SeaEQ):void
  // {
  //   var container:Container = new Container();
  //   container.EQsize = seaEQ.EQsize;
  //   container.EQtype = seaEQ.EQtype;
  //   container.job = job;
  // }
  //
  // /**
  //  * 删除箱子
  //  *
  //  * @param containers 待删除列表
  //  * @param count 要删除的数量
  //  */
  // private function removeContainer(containers:IList, count:int):void
  // {
  //   for (var i:int = 0; i < count; i++)
  //   {
  //     var len:int = containers.length;
  //     for (var j:int = len - 1; j >= 0; j++)
  //     {
  //       var container:Container = containers.getItemAt(j) as Container;
  //       if (removeable(container))
  //       {
  //         containers.removeItemAt(j);
  //         container.job = null;
  //         break;
  //       }
  //     }
  //   }
  // }
  //
  // /**
  //  * @private
  //  */
  // private function removeable(container:Container):Boolean
  // {
  //   return container.containerUsage == null || container.containerUsage.length == 0;
  // }
  //
  /**
   * 获取未装箱的小票
   */
  getUnboxedSlaves() {
    const slaves = []
    if (this.job.masterFlag) {
      for (const slave of this.job.lclSlaves) {
        if (!slave.hasOwnProperty('containerUsages') || slave.containerUsages === null || slave.containerUsages.length === 0) {
          slaves.push(slave)
        } else {
          // 确认是否所有件数都已经装箱，如果有未装箱的，那么放在候选列表里面
          let quantity = slave.quantityContract
          for (const usage of slave.containerUsages) { quantity -= usage.quantity }

          if (quantity > 0) { slaves.push(slave) }
        }
      }
    }
    return slaves
  }

  /**
   * 批量装箱
   */
  multiLoadContainer(slaves, container) {
    const usages = []
    for (const slave of slaves) {
      usages.push(this.loadContainer(slave, container))
    }
    return usages
  }

  /**
   * 装箱
   */
  loadContainer(slave, container) {
    if (container.containerUsage === null) { container.containerUsage = [] }

    let usage = this.getExistUsage(slave, container)

    if (usage === null) {
      usage = new ContainerUsage().fillDefaultValue().getData()

      usage.isDirty = true

      // todo usage.job = slave
      usage.jobUuid = slave.uuid
      if (!slave.containerUsages) {
        slave.containerUsages = []
      }
      slave.containerUsages.push(usage)

      // todo usage.container = container
      usage.containerUuid = container.uuid
      // 新增的箱子 无uuid 给个标识 用于 refreshContainerUsageColl 方法中的判断
      if (StrUtils.isEmpty(usage.containerUuid)) {
        usage.containerUuid = '-1'
      }
      if (!container.containerUsage) {
        container.containerUsage = []
      }
      container.containerUsage.push(usage)

      usage.quantity = this.getItemLeft(slave)
      usage.weight = this.getWeightLeft(slave)
      usage.cubage = this.getCubageLeft(slave)

      // 工作号上的相关信息
      usage.jobNo = slave.jobNo
      usage.warehouseNo = slave.warehouseNo
      usage.mbl = slave.mbl
      usage.customerId = slave.customerId
      usage.soNo = slave.soNo
      usage.dischargingPortCode = slave.dischargingPortCode
      usage.destinationPortCode = slave.destinationPortCode
      usage.etd = slave.etd
    } else {
      usage.isDirty = true
      usage.quantity = Number(usage.quantity) + this.getItemLeft(slave)
      usage.weight = Number(usage.weight) + this.getWeightLeft(slave)
      usage.cubage = Number(usage.cubage) + this.getCubageLeft(slave)
    }
    return usage
  }
  getItemLeft(input) {
    let quantity = 0
    quantity = input.quantityContract
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return Number(quantity)
  }
  getWeightLeft(input) {
    let weight = 0
    weight = input.weightContract
    if (isNaN(weight)) weight = 0.0

    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return Number(weight)
  }
  getCubageLeft(input) {
    let cubage = 0
    cubage = input.cubageContract
    if (isNaN(cubage)) cubage = 0.0
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) { usedCubage = 0.0 }
      cubage = cubage - usedCubage
    }
    return Number(cubage)
  }
  /**
   * 批量卸载箱量
   */
  multiUnloadContainer(usages) {
    if (usages != null && usages.length > 0) {
      for (let i = usages.length - 1; i >= 0; i--) {
        this.unloadContainer(usages[i])
      }
    }
  }

  /**
   * 卸载箱量
   */
  unloadContainer(usage) {
    if (!this.checkRemoveSourceUsagesExist(usage)) {
      this.removeSourceUsages.push({ 'usage': usage, 'job': usage.jobUuid })
    }

    // todo  usage.job = null
    // 删除 slave 上的 usage
    const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
    if (slave && slave.containerUsages) {
      const index = slave.containerUsages.findIndex(p => p.containerUuid === usage.containerUuid)
      slave.containerUsages.splice(index, 1)
    }
    usage.jobUuid = ''

    usage.containerUuid = '' // todo usage.container = null

    if (!StrUtils.isEmpty(usage.uuid)) {
      const actionItem = {}
      actionItem.node = 'unloadContainer'
      actionItem.action = 'DELETE'
      actionItem.entity = usage
      this.removedContainerUsages.push(actionItem)
    }
  }

  checkRemoveSourceUsagesExist(usage) {
    for (const item of this.removeSourceUsages) {
      const tagUsage = item['usage']
      if (tagUsage === usage) {
        return true
      }
    }
    return false
  }

  /**
   * 获取箱子中已经存在的对应的用量信息
   */
  getExistUsage(slave, container) {
    let usage = null
    for (const containerUsage of container.containerUsage) {
      if (containerUsage.jobUuid === slave.uuid) {
        usage = containerUsage
        break
      }
    }
    if (this.removedContainerUsages !== null && this.removedContainerUsages.length > 0) {
      for (let i = this.removedContainerUsages.length - 1; i >= 0; i--) {
        const action = this.removedContainerUsages[i]
        var usageEntity = action.entity
        const usegeSourceItem = this.getRemoveSourceUsages(usageEntity)
        if (usegeSourceItem != null) {
          const jobUuid = usegeSourceItem['job']
          if (jobUuid === slave.uuid) {
            usage = usegeSourceItem['usage']

            // todo usage.job = slave
            usage.jobUuid = slave.uuid
            if (!slave.containerUsages) {
              slave.containerUsages = []
            }
            slave.containerUsages.push(usage)

            // todo usage.container = container
            usage.containerUuid = container.uuid
            if (!container.containerUsage) {
              container.containerUsage = []
            }
            container.containerUsage.push(usage)

            this.removeSourceUsages.indexOf(usegeSourceItem)
            const index = this.removeSourceUsages.indexOf(usegeSourceItem)
            this.removeSourceUsages.splice(index, 1)

            this.removedContainerUsages.splice(i, 1)
            break
          }
        }
      }
    }
    return usage
  }

  getRemoveSourceUsages(usageEntity) {
    for (const item of this.removeSourceUsages) {
      const tagUsage = item['usage']
      if (tagUsage === usageEntity) {
        return item
      }
    }
    return null
  }

  /**
   * 验证小票箱量分配是否正确
   */
  validateSlavesUsage() {
    let msg = ''
    for (const slave of this.job.lclSlaves) {
      const warning = this.validateSlaveUsage(slave)
      if (warning.length > 0) {
        if (msg.length > 0) { msg += '<br/>' }
        msg += warning
      }
    }
    return msg
  }

  /**
   * 验证小票箱量分配是否正确
   */
  validateSlaveUsage(slave) {
    let sumQuantity = 0
    let sumWeight = 0
    let sumCubage = 0
    const weightActual = Number((Math.round(slave.weightContract * 100) / 100).toFixed(2))
    const cubageActual = Number((Math.round(slave.cubageContract * 1000) / 1000).toFixed(3))
    for (const usage of slave.containerUsages) {
      sumQuantity += Number(usage.quantity)
      sumWeight += Number(usage.weight)
      sumCubage += Number(usage.cubage)
    }
    sumQuantity = Number(sumQuantity.toFixed())
    sumWeight = Number((Math.round(sumWeight * 100) / 100).toFixed(2))
    sumCubage = Number((Math.round(sumCubage * 1000) / 1000).toFixed(3))
    let msg = ''
    if (sumQuantity > slave.quantityContract) { msg += i18n.t('SeaExport.QuantityOfBoxesAndPieces') + sumQuantity + i18n.t('SeaExport.GreaterActualNumberOfPieces') + slave.quantityContract }
    if (sumWeight > weightActual) { msg += i18n.t('SeaExport.BoxWeight') + sumWeight + i18n.t('SeaExport.GreaterThanActualWeight') + weightActual }
    if (sumCubage > cubageActual) { msg += i18n.t('SeaExport.BoxVolume') + sumCubage + i18n.t('SeaExport.LargerThanActualVolume') + cubageActual }
    if (msg.length > 0) { msg = i18n.t('SeaExport.JobNoColon') + slave.jobNo + '-' + msg }
    return msg
  }
}
